module.exports = __webpack_public_path__ + "static/media/kathmandu.81da34b4.jpeg";